const priceContracts: { rim: string; wBNB: string; rimBNBLP: string; usdt: string; bnbBUSDLP: string } = {
  rim: '0x363E23D1e0c8b06Ff0684f7Ed6eFE0A83541a424',
  wBNB: '0x21C718C22D52d0F3a789b752D4c2fD5908a8A733',
  rimBNBLP: '0xf6e0656162c471e27bcf23ab6626ad5f66b70e18',
  usdt: '0xdc19a122e268128b5ee20366299fc7b5b199c8e3',
  bnbBUSDLP: '0x8d82559a91929dd72682f5c6e2eea3905b6c2a18',
}

export default priceContracts
